<template>
  <div>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="类型" prop="type">
      <dict-select v-model="form.data.type" dict-code="INDEX_POSTER_TYPE"/>
<!--      <a-input v-model="form.data.type"/>-->
    </a-form-model-item>
    <a-form-model-item label="图片(小程序240*382网站500*617)" v-if="form.data.type==='IMAGE'">
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.inspirationImg"
          :imageUrl="form.data.inspirationImg"
          :options="coverOptions"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="视频封面" prop='videoCover' v-if="form.data.type==='VIDEO'">
      <div class="a-input">
        <simple-uploader v-model="form.data.videoCover"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="视频" v-if="form.data.type==='VIDEO'">
      <span class="help-tip" slot="extra" style="cursor: pointer" @click="reviewVideo">{{$t('PREVIEW') || '预览' }}</span>
      <div class="a-input">
        <simple-uploader v-model="form.data.inspirationVideo" :type="form.data.type"/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!inspirationId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="inspirationId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
  <a-modal
    :footer="null"
    append-to-body
    title="视频预览"
    v-model="video.visible">
    <video
      v-if="video.visible"
      ref="video"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="ture"
      x5-video-orientation="portraint"
      style="width: 100%;height: auto"
      autoplay
      preload="auto"
      muted="true"
      :src="form.data.inspirationVideo">
      您的浏览器不支持 HTML5
    </video>
  </a-modal>
  </div>
</template>

<script>
import {
  _queryInspiration,
  _addInspiration,
  _updateInspiration,
} from '@/api/goodsInspirationApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
// import MultiUploader from '../../../components/MultiUploader.vue';
import DictSelect from '../../../components/DictSelect.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getInspiration() {
  const result = await _queryInspiration(this.inspirationId);
  if (result) {
    this.form.data.type = result.type;
    this.form.data.inspirationImg = result.inspirationImg;
    this.form.data.inspirationVideo = result.inspirationVideo;
    this.form.data.videoCover = result.videoCover;
    // this.form.data.type = result.type;
  }
}

async function onAdd() {
  console.log(this.goodsId);
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addInspiration({
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg,
        inspirationVideo: this.form.data.inspirationVideo,
        videoCover: this.form.data.videoCover,
        goodsId: this.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}
function reviewVideo() {
  if (this.form.data.inspirationVideo) {
    this.video.visible = true;
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateInspiration(this.inspirationId, {
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg,
        inspirationVideo: this.form.data.inspirationVideo,
        videoCover: this.form.data.videoCover,
        goodsId: this.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsInspirationEdit',
  components: {
    CropperUploader,
    SimpleUploader,
    // MultiUploader,
    DictSelect,
  },
  props: {
    inspirationId: String,
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    inspirationId() {
      if (this.inspirationId) {
        this.getInspiration();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getInspiration,
    reviewVideo,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 240, // 默认生成截图框宽度
        autoCropHeight: 380, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'OSS',
        title: '修改图片',
      },
      form: {
        data: {
          type: 'IMAGE',
          inspirationImg: '',
          inspirationVideo: '',
          videoCover: '',
        },
        rules: {
          // name: [{ required: true, trigger: 'blur' }],
          // nameEn: [{ required: true, trigger: 'blur' }],
          // coverPath: [{ required: true, trigger: 'blur' }],
          // isVip: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.inspirationId) {
      this.getInspiration();
    }
  },
};
</script>
